import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb67297f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", { class: "breadcrumb" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item active" }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-current": "location" }, "Forums")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "display-4" }, "Forums index", -1))
const _hoisted_4 = { class: "mt-2 d-block" }
const _hoisted_5 = { class: "card mb-1" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TitleTag"], { title: "Forums index" }),
    ($setup.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.forums, (forum) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    class: "forum-name stretched-link",
                    to: {name:'forum',params:{id:forum.id}}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(forum.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _hoisted_7,
                  _createElementVNode("span", null, _toDisplayString(forum.description), 1)
                ])
              ]))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}